// ----------------------------------------------------------------------

export const account = {
  displayName: 'ธนัญชัย สิทธิกุล',
  email: 'demo@minimals.cc',
  photoURL: '/assets/images/avatars/avatar_25.jpg',
};
